define(['jquery',
        'core/urls',
        "components/modal",
        'components/dropdown',
        'core/utilities',
],
function($, 
    urls, 
    modal,
    DD,
    utilities
) {
        let nodes = {
            logoPicker: document.querySelector(".logo-picker_js"),
            modalUploadLogoContent: document.querySelector('.modal-template-upload_js'),
            progress: document.querySelector(".marketing-loader"),
            languageDropdown: document.querySelector(".language-selector"),
            generateSnippetButton: document.querySelector(".generate-snippet"),
            imgPreview: {
                withLogo: document.querySelector(".conf-mail-withlogo_js"),
                noLogo: document.querySelector(".conf-mail-nologo_js"),
                controls: document.querySelector(".conf-mail-upload-ctrl_js"),
                openBtn: document.querySelector(".uploader-open_js"),
                minusLogo: document.querySelector(".uploader-delete-logo_js")
            },
            googleMasterToggle: document.querySelector("#id_ask_for_google_review"),
            allGoogleInputs: document.querySelectorAll(".input-group.google-reviews input"),
            googleURL: document.querySelector("#id_google_link"),
            previewWrap: document.querySelector('.preview-panel'),
            previewNavWrap: document.querySelector('.preview-panel .previews'),
            previewNavItems: document.querySelectorAll('.preview-panel .previews .preview'),
            previewNavSlider: document.querySelector('.preview-panel .slide-bar'),
            previewContent: document.querySelector('.preview-panel .tab-content'),
            previewContentTabs: document.querySelectorAll('.preview-panel .tab-content .tab-pane'),
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".configuration-survey"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
        }

        let createdModal = modal.create(nodes.modal, function (el) {});
        let languageSelector;
        let searchParams;
        let snippetParams;
        let isPageLoad = true;

        let validationConfigs = [];
        let googleValidationConfigs = [
            {
                input: document.querySelector(".google-url-wrapper input"),
                errorNode: document.querySelector(".google-review-options .error-message.url"),
                validations: ["hasValue", "isValidURL"],
            },
            {
                input: document.querySelector(".google-review-options"),
                errorNode: document.querySelector(".google-review-options .error-message.checkboxes"),
                validations: ["hasSelectedCheckbox"],
            }
        ]
    
        let resizeIframe = (obj) => {
            let tabPane = obj.closest(".tab-pane");

            let tabIsActive = obj.closest(".tab-pane").classList.contains("active");
            if (!tabIsActive) {
                tabPane.classList.add("active");
            }
                
            setTimeout(() => {
                // Set height to 0 first to force a recalculation if the content shrinks
                obj.style.height = '0px'; 
                // Set the height to the content's scrollHeight
                obj.style.height = obj.contentWindow.document.body.scrollHeight + 20 + 'px';

                if (!tabIsActive) {
                    tabPane.classList.remove("active");
                }               
            }, 500);  
        }

        let generateSearchParams = () => {
            let googleUrl = $('#id_google_link').val().trim() === '' ? 'https://' : $('#id_google_link').val().trim();
            snippetParams = {
                logo: document.querySelector("#id_logo").value || 0,
                lang: languageSelector.info().value,
                publication: $('#id_ask_for_publication').prop('checked'),
                labels: $('#id_add_labels').prop('checked'),
                google_review_url: $('#id_ask_for_google_review').prop('checked') ? googleUrl : '',
                google_review_for_sentiment: [],
            };

            if($('#positive_google_reviews').prop('checked')) snippetParams.google_review_for_sentiment.push(1);
            if($('#neutral_google_reviews').prop('checked')) snippetParams.google_review_for_sentiment.push(0);
            if($('#negative_google_reviews').prop('checked')) snippetParams.google_review_for_sentiment.push(-1);

            searchParams = new URLSearchParams();
            Object.entries(snippetParams).forEach(([key, value]) => {
                if(typeof value === 'object' && value.length > 1) {
                    value.forEach(item => {
                        searchParams.append(key, item);
                    });
                } else {
                    searchParams.append(key, value);
                }
            });
        }

        let generateSnippet = () => {
            generateSearchParams();
        
            fetch(urls['configuration:snippet-generator']() + `?${searchParams.toString()}&testMode=false`, {
                method: 'GET',
                traditional: true
            })
            .then(response => response.text())
            .then((snippet) => {
                $('#js-survey-snippet').val(snippet);
            });
        }

        let generatePreviews = () => {
            nodes.previewWrap.classList.add('loading');

            generateSearchParams();
            
            // fetch email body
            fetch(urls['configuration:snippet-generator']() + `?${searchParams.toString()}&testMode=true`, {
                method: 'GET',
                traditional: true
            })
            .then(response => response.text())
            .then((body) => {
                $('#email-snippet').html(body);
                // fetch comment page
                fetch(urls['configuration:survey-preview']('submission') + '?' + searchParams.toString())
                .then(response => response.text())
                .then((body) => {
                    document.querySelector('#preview-submission').srcdoc = body;
                    resizeIframe(document.querySelector('#preview-submission'));
                    // fetch thank you page
                    fetch(urls['configuration:survey-preview']('post-submission') + '?' + searchParams.toString())
                    .then(response => response.text())
                    .then((body) => {
                        document.querySelector('#preview-post-submission').srcdoc = body;
                        resizeIframe(document.querySelector('#preview-post-submission'));

                        setTimeout(() => {
                            nodes.previewWrap.classList.remove('loading');
                            if(isPageLoad) {
                                nodes.previewContentTabs[0].classList.add('active');
                                handlePreviewForMobile();

                                window.addEventListener('resize', () => {
                                    handlePreviewForMobile();
                                });
                                isPageLoad = false;
                            }
                        }, 500);
                    });
                });
            });            
        }

        let addEventListeners = () => {
            let previewToggles = document.querySelectorAll('input.generate-preview');
            previewToggles.forEach(toggle => {
                toggle.addEventListener('change', function(e) {
                    generatePreviews();
                });
            });

            nodes.allGoogleInputs.forEach(input => {
                input.addEventListener('input', function() {
                    utilities.validateForm(googleValidationConfigs);
                    nodes.generateSnippetButton.classList.remove('disabled');

                    let activeErrors = document.querySelectorAll(".google-review-options .error-message:not(.hide)");
                    if(activeErrors.length > 0 && nodes.googleMasterToggle.checked) {
                        nodes.generateSnippetButton.classList.add('disabled');
                        return;
                    }
                });
            });

            nodes.previewWrap.addEventListener('click', function (e) {
                if(e.target.tagName === 'H2' && nodes.previewWrap.classList.contains('mobile-view')) {
                    nodes.previewWrap.scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            });

            $('#id_ask_for_google_review').change(function () {
                if($(this).prop('checked')){
                    document.querySelector('.google-review-options').classList.remove('hide');
                    document.querySelector('#id_google_link').disabled = false;
                } else {
                    document.querySelector('.google-review-options').classList.add('hide');
                    document.querySelector('#id_google_link').disabled = true;
                }
            });

            nodes.generateSnippetButton.addEventListener("click", function (e) {
                let updatedValidationConfig = [...validationConfigs];
                if(nodes.googleMasterToggle.checked) {
                    updatedValidationConfig.push(...googleValidationConfigs)
                }

                if(updatedValidationConfig.length > 0) {
                    let formIsValid = utilities.validateForm(updatedValidationConfig);

                    if (!formIsValid) {
                        return;
                    }
                }

                generateSnippet();

                let isScreenConnect = document.querySelector(".section.main-content").classList.contains("screen-connect");
                let snippetModal = document.querySelector(".modal-template-snippet_js");
                
                createdModal.open({
                    class: "error-modal",
                    content: snippetModal.innerHTML,
                    title: ""
                }, function (el) {
                    if(isScreenConnect) return;
                    
                    let originalSnippet = document.querySelector(".modal-template-snippet_js #js-survey-snippet");
                    let modalSnippet = document.querySelector(".sb-modal__content textarea");
                    let copyButton = document.querySelector(".sb-modal #js-survey-copysnippet")
                    modalSnippet.value = originalSnippet.value;
                    let hasBeenCopied = false;
                    
                    copyButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(modalSnippet.value)

                        if(hasBeenCopied) {
                            copyButton.classList.add("blink-once");
                            setTimeout(() => {
                                copyButton.classList.remove("blink-once");
                            }, 500);
                            return;
                        }
                        
                        copyButton.innerText = "Copied!"
                        hasBeenCopied = true;

                        let dashboardButton = document.querySelector(".button-wrap.dashboard");
                        dashboardButton.classList.remove("hide");
                    })
                });
            });
        }

        let handlePreviewForMobile = () => {
            // add 'bottom' value to preview panel for mobile/tablet
            let rect = nodes.previewContent.querySelector(".active").getBoundingClientRect();
            
            if(window.innerWidth <= 768) {
                nodes.previewWrap.style.bottom = `-${(rect.height + 162)}px`;
                nodes.previewWrap.classList.add('mobile-view');
            } else if(window.innerWidth <= 1024) {
                nodes.previewWrap.style.bottom = `-${(rect.height + 78)}px`;
                nodes.previewWrap.classList.add('mobile-view');
            } else {
                nodes.previewWrap.style.bottom = 'unset';
                nodes.previewWrap.classList.remove('mobile-view');
            }
        }

        return {
            init: function() {
                languageSelector = DD(nodes.languageDropdown, (value) => {
                    if(value === 'ar' || value === 'he' || value === 'fa' || value === 'ur') {
                        let textWrappers = document.querySelectorAll('.fake-text');
                        textWrappers.forEach(wrapper => {
                            wrapper.classList.add('rtl');
                        });
                    } else {
                        document.querySelectorAll('.fake-text.rtl').forEach(wrapper => {
                            wrapper.classList.remove('rtl');
                        });
                    }
                    generatePreviews();
                });

                let previewSliderConfig = {
                    parent: nodes.previewNavWrap,
                    slider: nodes.previewNavSlider,
                    callback: (event) => {
                        nodes.previewContent.querySelector(".active").classList.remove("active");
                        let targetTab = nodes.previewContent.querySelector(`[data-content="${event.target.dataset.title}"]`);
                        targetTab.classList.add("active");

                        handlePreviewForMobile();
                    },
                }

                nodes.previewNavItems.forEach(preview => {    
                    utilities.applySlider(preview, previewSliderConfig)
                });

                utilities.enableLogoPicker(nodes.modal, () => {
                    generatePreviews();
                });
                
                generatePreviews();
                addEventListeners();
            }
        };
    }
);
